import Image from "next/image";
import Link from "next/link";

import { usePermission } from "@/features/auth/shared/hooks/use-permission";
import { useDialog } from "@/hooks/use-dialog";
import { Lang } from "@/i18n-config";
import { getTranslations } from "@/utils/i18n/get-translations";

import { Button } from "ui/core/button";

const SlidesOpenButton = ({
  symbol,
  isHasQuartrSlides,
  lang,
}: {
  symbol: string;
  isHasQuartrSlides: boolean;
  lang: Lang;
}) => {
  const { t } = getTranslations(lang);
  const isHasQuartrSlidesPermission = usePermission("Basic Monthly");
  const { Dialog, openDialog, closeDialog } = useDialog({
    isMobileFullScreen: false,
  });

  const handleOpenQuartrSlides = () => {
    if (isHasQuartrSlidesPermission) {
      window.open(
        `/api/reports/latest-financial-report-slides/${symbol}`,
        "_blank"
      );
    } else {
      openDialog();
    }
  };
  return (
    <div>
      <Button
        variant="secondary"
        aria-label="Open TradingView Chart"
        className="flex items-center gap-2 px-1 text-sky-700 sm:px-4"
        disabled={!isHasQuartrSlides}
        onClick={handleOpenQuartrSlides}
      >
        <Image
          src="/quartr/logo.svg"
          alt="Quartr Logo"
          width={20}
          height={20}
        />
        {t.analysis.viewSlides}
      </Button>
      {isHasQuartrSlides ? (
        <div className="mt-1 flex w-full justify-center text-center text-[10px] text-zinc-400">
          (Powered by{" "}
          <Link
            href="https://quartr.com/products/quartr-api"
            target="_blank"
            className="ml-1 block"
          >
            <Image
              src="/quartr/logo-with-text-gray.svg"
              alt="Quartr Logo"
              className="relative top-[2px]"
              width={48}
              height={12}
            />
          </Link>
          )
        </div>
      ) : (
        <div className="item-center mt-1 block text-center text-[10px] text-zinc-400">
          ({t.analysis.viewSlidesNoFile({ symbol })})
        </div>
      )}
      <Dialog
        onClose={closeDialog}
        title={t.analysis.viewSlidesDialogNoPermissionTitle}
      >
        <div className="flex flex-col items-center gap-2 p-4">
          <p className="mb-4 text-center text-sm text-zinc-600">
            {t.analysis.viewSlidesDialogNoPermissionContent}
          </p>
          <Button
            variant="primary"
            className="w-[300px]"
            onClick={() => {
              window.open(`/${lang}/stockmining-pricing`, "_blank");
            }}
          >
            {t.analysis.viewSlidesDialogNoPermissionButtonText}
          </Button>
        </div>
      </Dialog>
    </div>
  );
};

export default SlidesOpenButton;
